// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"5f22b6a5","54":"5f22b6a5","512":"5f22b6a5"}[chunkId] + ".chunk.css";
};